'use client';

import { WebViewEventParams, WebViewEventType } from '@diritto/common/app/webview-event.constant';
import { WebViewScreen } from '@diritto/common/app/webview-header.constant';
import { Color } from '@diritto/common/style/color';
import { DirittoAppBridge } from 'libs/DirittoAppBridge';
import { useCallback, useEffect } from 'react';
import { useClient } from 'ui-hooks/useClient';

export type ChangeStatusBarParams = WebViewEventParams[WebViewEventType.ChangeStatusBar];

export const useInAppStatusBar = (webViewScreen: WebViewScreen) => {
  const client = useClient();

  const changeAppStatusBar = useCallback(
    (params: ChangeStatusBarParams) => {
      if (client.isApp) {
        DirittoAppBridge.changeStatusBar(params);
      }
    },
    [client.isApp],
  );

  useEffect(() => {
    changeAppStatusBar(DefaultStatusBar);
  }, [changeAppStatusBar, webViewScreen]);

  return { changeAppStatusBar };
};

export const DefaultStatusBar: ChangeStatusBarParams = {
  backgroundColor: Color.White,
  barStyle: 'dark-content',
  animation: 'fade',
};
